export class Energy {
    constructor({
      id = null,
      enyCode = '',
      enyName = '',
      enyType = '',
      // matModel='',
      // matSpec='',
      enyUnit = '',
      
    } = {}) {
  
        this.id = id;
        this.enyCode = enyCode; 
        this.enyName = enyName; 
        this.enyType = enyType;
        // this.matModel = matModel;
        // this.matSpec = matSpec;
        this.enyUnit=enyUnit;
    }
  }
  
  
  export function gridFields() {
    return Object.freeze([{
          key: 'enyCode',
          label: 'lbl.basic.code',
          sortable: true,
          form: {
            type: 'input'
        }
        },
        {
          key: 'enyName',
          label: 'lbl.basic.name',          
          form: {
            type: 'input'
        }
        },
        {
          key: 'enyType',
          label: 'lbl.basic.type',
          sortable: true,
          form: {
              type: 'select',
              options: [
                  { value: null, text: '' },
                  { value: 'S', text: '固体能源' },
                  { value: 'G', text: '气体能源' },
                  { value: 'F', text: '液体能源' },
                ]
          }         
      },
        {
          key: 'enyUnit',
          label: 'lbl.material.unit',         
          form: {
            type: 'input'
        }
        },
    ]);
  }
  
  export const fields = Object.freeze(Object.keys(new Energy()).map(i => 'entity.' + i));
  
  export const filterFields = [
    'filter.enyCodeFilter',
    'filter.enyNameFilter',
    'filter.enyTypeFilter',
   
  ];
  
  export const filter = {
    'enyCodeFilter': "",
    'enyNameFilter': "",
    'enyTypeFilter': "",
   
    };